import { userConstants } from '../constants/user.constants.js';

export default function addCreditRetirements(state = {}, action) {
    switch (action.type) {
        case userConstants.ADD_CCR_SUCCESS:
            return {
                ...state,
                data: action.payload
            }
            
        case userConstants.ADD_CCR_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        default:
            return state
    }
}